import './App.css';
import LOGO from './assets/images/logo.svg'
import '@fortawesome/fontawesome-free/css/all.css'
import PDFAsImage from './components/PdfAsImage/PdfAsImage';
import MENUPDf from './assets/menu.pdf'

const menu = [
  {
    title: 'Cocktails',
    items: [
      {
        name: 'Cocktail pieces',
        price: [3.5, 4.5, 5.5],
      },
      {
        name: 'Exotic pieces',
        price: [5, 7, 9],
      },
      {
        name: 'Juice Cocktail',
        price: [3.5, 4, 4.5],
      },
      {
        name: 'Avocado',
        price: [6, 7, 8],
      },
      {
        name: 'Avocado + Juice',
        price: [5, 6, 7],
      },
      {
        name: 'Avocado + Strawberry',
        price: [5, 6, 7],
      },
      {
        name: 'Milk + Bananas + Honey',
        price: [2.5, 3, 3.5],
      },
      {
        name: 'Turbo',
        price: [7, 8, 9],
      },
    ]
  },
  {
    title: 'Juices',
    items: [
      {
        name: 'Orange',
        price: [2, 2.5, 3],
      },
      {
        name: 'Carrot',
        price: [3, 3.5, 4],
      },
      {
        name: 'Apple Juice',
        price: [2.5, 3.5, 4.5],
      },
      {
        name: 'Lemonade',
        price: [2.5, 3, 3.5],
      },
      {
        name: 'Watermelon',
        price: [2.5, 3, 3.5],
      },
      {
        name: 'Melon',
        price: [2.5, 3, 3.5],
      },
      {
        name: 'Kiwi',
        price: [4, 5, 6],
      },
      {
        name: 'Pineapple',
        price: [5, 6.5, 8],
      },
      {
        name: 'Strawberry',
        price: [3, 3.5, 4],
      },
    ]
  },
]

const plat = [
  {
    title: 'Crêpes',
    items: [
      {
        name: ' Oreo / Kinder / Nutella',
        price: 7
      },
      {
        name: 'Cocktelli',
        price: 9,
      },
    ]
  },
  {
    title: 'Ashta',
    items: [
      {
        name: '1/2 Kilo',
        price: 5.5
      },
      {
        name: 'Ashta plat normal',
        price: 8,
      },
      {
        name: 'Ashta plat exotic',
        price: 11,
      },
    ]
  }
]

const adds = {
  title: 'Add',
  items: [
    {
      name: 'Nuts',
      price: 1
    },
    {
      name: 'Ashta',
      price: 1
    },
    {
      name: 'Nutella',
      price: 1
    },
  ]
}

const handleWhatsAppClick = () => {
  window.open('https://api.whatsapp.com/send?phone=96176857001');
};


function App() {
  return (
    <>
      <PDFAsImage file={MENUPDf} />
      <button
        className="fixed bottom-4 right-4 w-16 h-16 bg-green-500 text-white rounded-full flex items-center justify-center"
        onClick={handleWhatsAppClick}
      >
        <i className='fab fa-whatsapp fa-2xl' />
      </button>
    </>
  )

  // return (
  //   <div>
  //     <div className='bg-green-950 bg-cover bg-center w-full h-auto lg:px-96 px-5 py-5'>
  //       <div className='flex flex-col items-center justify-center'>
  //         <img src={LOGO} alt='logo' className='lg:w-96 w-64 h-64' />
  //       </div>
  //       {menu.map((men, index) => (
  //         <div className='mb-10' key={index}>
  //           <div className='h-10 text-center bg-green-500'>
  //             <h1 className='text-2xl text-white font-bold font-[georgia]'>{men?.title}</h1>
  //           </div>
  //           <div className='flex flex-row text-center lg:mt-10 mt-5 text-orange-300'>
  //             <div className='flex-1'></div>
  //             <div className='flex-1'>
  //               S
  //             </div>
  //             <div className='flex-1'>
  //               M
  //             </div>
  //             <div className='flex-1'>
  //               L
  //             </div>
  //           </div>
  //           {men?.items?.map((item, index) => (
  //             <div className='flex flex-row text-center mt-5' key={index}>
  //               <div className='flex-1'>
  //                 <div className='text-orange-300 text-start font-semibold'>
  //                   {item?.name}
  //                 </div>
  //               </div>
  //               {item?.price?.map((pric, priceIndex) => (
  //                 <div className='flex-1 text-green-300' key={priceIndex}>
  //                   {pric}$
  //                 </div>
  //               ))}
  //             </div>
  //           ))}
  //           <div className='divider h-[1px] bg-green-300 mt-8'></div>
  //         </div>
  //       ))}
  //       {plat?.map(pla => (
  //         <div className='mb-10'>
  //           <div className='h-10 text-center bg-green-500'>
  //             <h1 className='text-center text-2xl text-white font-bold font-[georgia]'>{pla?.title}</h1>
  //           </div>
  //           {pla?.items?.map(item => (
  //             <div className='flex flex-row text-center lg:mt-10 mt-5 '>
  //               <div className='flex-1 text-orange-300 font-semibold'>{item?.name}</div>
  //               <div className='flex-1 text-green-300'>
  //                 {item?.price}$
  //               </div>
  //             </div>
  //           ))}
  //           <div className='divider h-[1px] bg-green-300 mt-8'></div>
  //         </div>
  //       ))}
  //       <div className='flex flex-row'>
  //         <div className='flex-1 text-center text-orange-300 '>
  //           Water
  //         </div>
  //         <div className='flex-1'>
  //           <span className='text-orange-300'>B:</span>
  //           <span className='text-green-300'> 0.6$</span>
  //         </div>
  //         <div className='flex-1'>
  //           <span className='text-orange-300'>S:</span>
  //           <span className='text-green-300'> 0.4$</span>
  //         </div>
  //       </div>
  //         <div className='mb-10 mt-10'>
  //           {adds?.items?.map(item => (
  //             <div className='flex flex-row text-center lg:mt-10 mt-5 '>
  //               <div className='flex-1 text-orange-300 font-semibold'>Add {item?.name}</div>
  //               <div className='flex-1 text-green-300'>
  //                 {item?.price}$
  //               </div>
  //             </div>
  //           ))}
  //           <div className='divider h-[1px] bg-green-300 mt-8'></div>
  //         </div>
  //       <div className='mt-5 text-center text-white'>
  //         <p>For Delivery call us on: </p>
  //         <i className="fas fa-phone"> 76857001</i>
  //       </div>
  //     </div>
  //     <div className='flex flex-row w-full h-16 bg-orange-500'>
  //       <div className='flex-1 text-center'>
  //         <h2 className='text-black font-bold mt-3 text-xl'>Follow Us</h2>
  //       </div>
  //       <div className='flex-1 mt-3 text-center space-x-2'>
  //         <a href='https://www.facebook.com/profile.php?id=61550688509579&mibextid=b06tZ0' target='_blank' rel='noopener noreferrer'>
  //           <i className="fab fa-facebook fa-2xl text-blue-800"></i>
  //         </a>
  //         <a href='https://instagram.com/cocktelli?igshid=MzRlODBiNWFlZA==' target='_blank' rel='noopener noreferrer'>
  //           <i className="fab fa-instagram fa-2xl text-pink-800"></i>
  //         </a>
  //         <a href='https://www.tiktok.com/@cocktelli?_t=8fMg9h4jvgv&_r=1' target='_blank' rel='noopener noreferrer'>
  //           <i className="fab fa-tiktok fa-2xl text-black"></i>
  //         </a>
  //       </div>
  //     </div>
  //     <button
  //     className="fixed bottom-16 right-4 w-20 h-20 bg-green-500 text-white rounded-full flex items-center justify-center"
  //     onClick={handleWhatsAppClick}
  //   >
  //     <i className='fab fa-whatsapp fa-2xl'/>
  //   </button>
  //   </div>
  // );
}

export default App;
